import SubscriptionCategory from "./subscription-category";

export default SubscriptionCategory